import { render, staticRenderFns } from "./InstrumentEdit_new.vue?vue&type=template&id=0171a648&"
import script from "./InstrumentEdit_new.vue?vue&type=script&lang=js&"
export * from "./InstrumentEdit_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports